import React from "react";
import {Box, Checkbox, Typography,} from "@mui/material";
import {getPerc} from "../svc/Utils";

export default function OtherScale({scalecolor, text, dpe, changeState, title, chV1, chV2, size}) {
    const [state, setState] = React.useState({
        "A": true,
        "B": true,
        "C": true,
        "D": true,
        "E": true,
        "F": true,
        "G": true
    });


    function getWidth(props, dpeElement, nbDpesV2) {
        let max = 0
        Object.keys(dpe).map((d) => {
            if (max < parseInt(dpe[d])) {
                max = parseInt(dpe[d])
            }
        })

        return "calc(" + props + "px * " + (dpeElement) * 1 / (max) + ")";
    }

    function getColor(color, value) {
        let max = 0
        Object.keys(dpe).map((d) => {
            if (max < parseInt(dpe[d])) {
                max = parseInt(dpe[d])
            }
        })
        if (value === max) {
            return "#ca097f"
        }
        return color;
    }

    function getTextColor(value) {
        let max = 0
        Object.keys(dpe).map((d) => {
            if (max < parseInt(dpe[d])) {
                max = parseInt(dpe[d])
            }
        })
        if (value === max) {
            return "#FFF"
        }
        return "#000";
    }

    const [nbDpesV2, setNbDpesV2] = React.useState(null)


    React.useEffect(() => {
        if (dpe) {
            let total = 0
            Object.keys(dpe).map((d) => {
                total += parseInt(dpe[d])
            })
            setNbDpesV2(total)
        }
    }, [dpe]);

    if (dpe && nbDpesV2) {
        return (
            <Box sx={{width: "20%", ml: 1, mr: 1,mb:2}}>
                <Box sx={{width: 250, display: "flex", height: 25, alignItems: "center", marginBottom: 1}}>
                    <Typography sx={{width: "100%", textAlign: "center", fontWeight: 800 ,color:"#fff",backgroundColor:"#1f0d88"}}
                                variant="subtitle1">{title}</Typography>
                    {chV1}
                    {chV2}
                </Box>
                {text.A && <Box sx={{
                    width: 250,
                    height: 22,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between"
                }}>
                    {changeState && <Checkbox sx={{p: 0}} size="small" checked={state.A} onClick={() => {
                        let tmpState = {...state, A: !state.A};
                        setState(tmpState)
                        changeState(tmpState);
                    }}/>}

                    <Box sx={{
                        width: size,
                        backgroundColor: getColor(scalecolor.A, dpe.A),
                        height: 20,
                        borderTopLeftRadius: 8,
                        borderBottomLeftRadius: 8,
                        display: "flex",
                        alignItems: "center",
                        textOverflow: "ellipsis", whiteSpace: "nowrap"
                    }}>
                        <Typography sx={{width: "100%", fontWeight: 'bold', pl: 1, color: getTextColor(dpe.A)}}>
                            {text.A}</Typography>
                    </Box>
                    <Box sx={{
                        width: "calc(250px - 20px - 5px -  " + size + "px)",
                        height: 20,

                        display: "flex",
                        alignItems: "center"
                    }}>
                        <Box sx={{
                            width: getWidth(190, dpe["A"], nbDpesV2),
                            backgroundColor: getColor(scalecolor.A, dpe.A),
                            borderTopRightRadius: 8,
                            borderBottomRightRadius: 8,
                            height: 20,
                        }}/>
                        <Box sx={{
                            position: "absolute",
                            zIndex: 99,
                            width: "calc(250px - 20px - 5px -  " + size + "px)",
                            height: 20,
                            display: "flex",
                            alignItems: "center",
                            textOverflow: "ellipsis", whiteSpace: "nowrap"
                        }}>
                            <Typography
                                sx={{
                                    width: "50%",
                                    pl: 1,
                                    display: "flex",
                                    justifyContent: "center", color: getTextColor(dpe.A)
                                }}>
                                {dpe["A"]}
                            </Typography>
                            <Typography
                                sx={{
                                    width: "50%",
                                    pl: 1,
                                    display: "flex",
                                    justifyContent: "center", color: getTextColor(dpe.A)
                                }}>
                                {getPerc((dpe["A"]) / (nbDpesV2))}
                            </Typography>
                        </Box>
                    </Box>


                </Box>}
                {text.B && <Box sx={{
                    width: 250,
                    height: 22,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between"
                }}>
                    {changeState && <Checkbox sx={{p: 0}} size="small" checked={state.B} onClick={() => {
                        let tmpState = {...state, B: !state.B};
                        setState(tmpState)
                        changeState(tmpState);

                    }}/>}
                    <Box sx={{
                        width: size,
                        backgroundColor: getColor(scalecolor.B, dpe.B),
                        height: 20,
                        borderTopLeftRadius: 8,
                        borderBottomLeftRadius: 8,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        textOverflow: "ellipsis", whiteSpace: "nowrap"
                    }}>
                        <Typography sx={{width: "100%", fontWeight: 'bold', pl: 1, color: getTextColor(dpe.B)}}>
                            {text.B}</Typography>
                    </Box>
                    <Box sx={{
                        width: "calc(250px - 20px - 5px -  " + size + "px)",
                        height: 20,

                        display: "flex",
                        alignItems: "center"
                    }}>
                        <Box sx={{
                            width: getWidth(190, dpe["B"], nbDpesV2),
                            backgroundColor: getColor(scalecolor.B, dpe.B),
                            borderTopRightRadius: 8,
                            borderBottomRightRadius: 8,
                            height: 20,
                        }}/>
                        <Box sx={{
                            position: "absolute",
                            zIndex: 99,
                            width: "calc(250px - 20px - 5px -  " + size + "px)",
                            height: 20,
                            display: "flex",
                            alignItems: "center"
                        }}>
                            <Typography
                                sx={{
                                    width: "50%",
                                    pl: 1,
                                    display: "flex",
                                    justifyContent: "center", color: getTextColor(dpe.B)
                                }}>
                                {dpe["B"]}
                            </Typography>
                            <Typography
                                sx={{
                                    width: "50%",
                                    pl: 1,
                                    display: "flex",
                                    justifyContent: "center", color: getTextColor(dpe.B)
                                }}>
                                {getPerc((dpe["B"]) / (nbDpesV2))}
                            </Typography>
                        </Box>
                    </Box>

                </Box>}
                {text.C && <Box sx={{
                    width: 250,
                    height: 22,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between"
                }}>
                    {changeState && <Checkbox sx={{p: 0}} size="small" checked={state.C} onClick={() => {
                        let tmpState = {...state, C: !state.C};
                        setState(tmpState)
                        changeState(tmpState);
                    }}/>}
                    <Box sx={{
                        width: size,
                        backgroundColor: getColor(scalecolor.C, dpe.C),
                        height: 20,
                        borderTopLeftRadius: 8,
                        borderBottomLeftRadius: 8,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        textOverflow: "ellipsis", whiteSpace: "nowrap"
                    }}>
                        <Typography sx={{width: "100%", fontWeight: 'bold', pl: 1, color: getTextColor(dpe.C)}}>
                            {text.C}</Typography>
                    </Box>
                    <Box sx={{
                        width: "calc(250px - 20px - 5px -  " + size + "px)",
                        height: 20,

                        display: "flex",
                        alignItems: "center"
                    }}>
                        <Box sx={{
                            width: getWidth(190, dpe["C"], nbDpesV2),
                            backgroundColor: getColor(scalecolor.C, dpe.C),
                            borderTopRightRadius: 8,
                            borderBottomRightRadius: 8,
                            height: 20,
                        }}/>
                        <Box sx={{
                            position: "absolute",
                            zIndex: 99,
                            width: "calc(250px - 20px - 5px -  " + size + "px)",
                            height: 20,
                            display: "flex",
                            alignItems: "center"
                        }}>
                            <Typography
                                sx={{
                                    width: "50%",
                                    pl: 1,
                                    display: "flex",
                                    justifyContent: "center", color: getTextColor(dpe.C)
                                }}>
                                {dpe["C"]}
                            </Typography>
                            <Typography
                                sx={{
                                    width: "50%",
                                    pl: 1,
                                    display: "flex",
                                    justifyContent: "center", color: getTextColor(dpe.C)
                                }}>
                                {getPerc((dpe["C"]) / (nbDpesV2))}
                            </Typography>
                        </Box>
                    </Box>


                </Box>}
                {text.D && <Box sx={{
                    width: 250,
                    height: 22,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between"
                }}>
                    {changeState && <Checkbox sx={{p: 0}} size="small" checked={state.D} onClick={() => {
                        let tmpState = {...state, D: !state.D};
                        setState(tmpState)
                        changeState(tmpState);
                    }}/>}
                    <Box sx={{
                        width: size,
                        backgroundColor: getColor(scalecolor.D, dpe.D),
                        height: 20,
                        borderTopLeftRadius: 8,
                        borderBottomLeftRadius: 8,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        textOverflow: "ellipsis", whiteSpace: "nowrap"
                    }}>
                        <Typography sx={{
                            width: "100%",
                            fontWeight: 'bold',
                            pl: 1,
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap", color: getTextColor(dpe.D)
                        }}>
                            {text.D}</Typography>
                    </Box>
                    <Box sx={{
                        width: "calc(250px - 20px - 5px -  " + size + "px)",
                        height: 20,

                        display: "flex",
                        alignItems: "center"
                    }}>
                        <Box sx={{
                            width: getWidth(190, dpe["D"], nbDpesV2),
                            backgroundColor: getColor(scalecolor.D, dpe.D),
                            borderTopRightRadius: 8,
                            borderBottomRightRadius: 8,
                            height: 20,
                        }}/>
                        <Box sx={{
                            position: "absolute",
                            zIndex: 99,
                            width: "calc(250px - 20px - 5px -  " + size + "px)",
                            height: 20,
                            display: "flex",
                            alignItems: "center"
                        }}>
                            <Typography
                                sx={{
                                    width: "50%",
                                    pl: 1,
                                    display: "flex",
                                    justifyContent: "center", color: getTextColor(dpe.D)
                                }}>
                                {dpe["D"]}
                            </Typography>
                            <Typography
                                sx={{
                                    width: "50%",
                                    pl: 1,
                                    display: "flex",
                                    justifyContent: "center", color: getTextColor(dpe.D)
                                }}>
                                {getPerc((dpe["D"]) / (nbDpesV2))}
                            </Typography>
                        </Box>
                    </Box>


                </Box>}
                {text.E && <Box sx={{
                    width: 250,
                    height: 22,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between"
                }}>
                    {changeState && <Checkbox sx={{p: 0}} size="small" checked={state.E} onClick={() => {
                        let tmpState = {...state, E: !state.E};
                        setState(tmpState)
                        changeState(tmpState);
                    }}/>}
                    <Box sx={{
                        width: size,
                        backgroundColor: getColor(scalecolor.E, dpe.E),
                        height: 20,
                        borderTopLeftRadius: 8,
                        borderBottomLeftRadius: 8,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        textOverflow: "ellipsis", whiteSpace: "nowrap"
                    }}>
                        <Typography sx={{
                            width: "100%",
                            fontWeight: 'bold',
                            pl: 1,
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap", color: getTextColor(dpe.E)
                        }}>
                            {text.E}</Typography>
                    </Box>
                    <Box sx={{
                        width: "calc(250px - 20px - 5px -  " + size + "px)",
                        height: 20,

                        display: "flex",
                        alignItems: "center"
                    }}>
                        <Box sx={{
                            width: getWidth(190, dpe["E"], nbDpesV2),
                            backgroundColor: getColor(scalecolor.E, dpe.E),
                            borderTopRightRadius: 8,
                            borderBottomRightRadius: 8,
                            height: 20,
                        }}/>
                        <Box sx={{
                            position: "absolute",
                            zIndex: 99,
                            width: "calc(250px - 20px - 5px -  " + size + "px)",
                            height: 20,
                            display: "flex",
                            alignItems: "center"
                        }}>
                            <Typography
                                sx={{
                                    width: "50%",
                                    pl: 1,
                                    display: "flex",
                                    justifyContent: "center", color: getTextColor(dpe.E)
                                }}>
                                {dpe["E"]}
                            </Typography>
                            <Typography
                                sx={{
                                    width: "50%",
                                    pl: 1,
                                    display: "flex",
                                    justifyContent: "center", color: getTextColor(dpe.E)
                                }}>
                                {getPerc((dpe["E"]) / (nbDpesV2))}
                            </Typography>
                        </Box>
                    </Box>

                </Box>}
                {text.F && <Box sx={{
                    width: 250,
                    height: 22,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between"
                }}>
                    {changeState && <Checkbox sx={{p: 0}} size="small" checked={state.F} onClick={() => {
                        let tmpState = {...state, F: !state.F};
                        setState(tmpState)
                        changeState(tmpState);
                    }}/>}
                    <Box sx={{
                        width: size,
                        backgroundColor: getColor(scalecolor.F, dpe.F),
                        height: 20,
                        borderTopLeftRadius: 8,
                        borderBottomLeftRadius: 8,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        textOverflow: "ellipsis", whiteSpace: "nowrap"
                    }}>
                        <Typography sx={{
                            width: "100%",
                            fontWeight: 'bold',
                            pl: 1,
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap", color: getTextColor(dpe.F)
                        }}>
                            {text.F}</Typography>
                    </Box>
                    <Box sx={{
                        width: "calc(250px - 20px - 5px -  " + size + "px)",
                        height: 20,

                        display: "flex",
                        alignItems: "center"
                    }}>
                        <Box sx={{
                            width: getWidth(190, dpe["F"], nbDpesV2),
                            backgroundColor: getColor(scalecolor.F, dpe.F),
                            borderTopRightRadius: 8,
                            borderBottomRightRadius: 8,
                            height: 20,
                        }}/>
                        <Box sx={{
                            position: "absolute",
                            zIndex: 99,
                            width: "calc(250px - 20px - 5px -  " + size + "px)",
                            height: 20,
                            display: "flex",
                            alignItems: "center"
                        }}>
                            <Typography
                                sx={{
                                    width: "50%",
                                    pl: 1,
                                    display: "flex",
                                    justifyContent: "center", color: getTextColor(dpe.F)
                                }}>
                                {dpe["F"]}
                            </Typography>
                            <Typography
                                sx={{
                                    width: "50%",
                                    pl: 1,
                                    display: "flex",
                                    justifyContent: "center", color: getTextColor(dpe.F)
                                }}>
                                {getPerc((dpe["F"]) / (nbDpesV2))}
                            </Typography>
                        </Box>
                    </Box>


                </Box>}
                {text.G && <Box sx={{
                    width: 250,
                    height: 22,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between"
                }}>
                    {changeState && <Checkbox sx={{p: 0}} size="small" checked={state.G} onClick={() => {
                        let tmpState = {...state, G: !state.G};
                        setState(tmpState)
                        changeState(tmpState);
                    }}/>}
                    <Box sx={{
                        width: size,
                        backgroundColor: getColor(scalecolor.G, dpe.G),
                        height: 20,
                        borderTopLeftRadius: 8,
                        borderBottomLeftRadius: 8,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        textOverflow: "ellipsis", whiteSpace: "nowrap"

                    }}>
                        <Typography sx={{
                            width: "100%",
                            fontWeight: 'bold',
                            pl: 1,
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap", color: getTextColor(dpe.G)
                        }}>
                            {text.G}</Typography>
                    </Box>
                    <Box sx={{
                        width: "calc(250px - 20px - 5px -  " + size + "px)",
                        height: 20,

                        display: "flex",
                        alignItems: "center"
                    }}>
                        <Box sx={{
                            width: getWidth(190, dpe["G"], nbDpesV2),
                            backgroundColor: getColor(scalecolor.G, dpe.G),
                            borderTopRightRadius: 8,
                            borderBottomRightRadius: 8,
                            height: 20,
                        }}/>
                        <Box sx={{
                            position: "absolute",
                            zIndex: 99,
                            width: "calc(250px - 20px - 5px -  " + size + "px)",
                            height: 20,
                            display: "flex",
                            alignItems: "center"
                        }}>
                            <Typography
                                sx={{
                                    width: "50%",
                                    pl: 1,
                                    display: "flex",
                                    justifyContent: "center", color: getTextColor(dpe.G)
                                }}>
                                {dpe["G"]}
                            </Typography>
                            <Typography
                                sx={{
                                    width: "50%",
                                    pl: 1,
                                    display: "flex",
                                    justifyContent: "center", color: getTextColor(dpe.G)
                                }}>
                                {getPerc((dpe["G"]) / (nbDpesV2))}
                            </Typography>
                        </Box>
                    </Box>


                </Box>}

            </Box>
        )
    }

}

/*
import React from "react";
import {
    Accordion, AccordionDetails, AccordionSummary,
    Box, Button, Checkbox,
    CircularProgress, FormControlLabel, FormGroup, TextField, Tooltip, Typography,

} from "@mui/material";
import DpeCtrl from "../svc/openapi/DpeCtrl";

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import LocalParkingIcon from '@mui/icons-material/LocalParking';
import TagIcon from '@mui/icons-material/Tag';
import ElectricBoltIcon from '@mui/icons-material/ElectricBolt';
import GroupWorkIcon from '@mui/icons-material/GroupWork';
import StoreIcon from '@mui/icons-material/Store';
import AirlineSeatFlatIcon from '@mui/icons-material/AirlineSeatFlat';
import WallpaperIcon from '@mui/icons-material/Wallpaper';
import HeightIcon from '@mui/icons-material/Height';
import {VictoryPie} from "victory";
import IconMSquare from "../ico/IconMSquare";
import IconMSquare2 from "../ico/IconMSquare2";
import IconPrise from "../ico/IconPrise";
import LineWeightIcon from '@mui/icons-material/LineWeight';
import AspectRatioIcon from '@mui/icons-material/AspectRatio';
import CorporateFareIcon from '@mui/icons-material/CorporateFare';
import ReactApexCharts from 'react-apexcharts'
import IconMaison from "../ico/IconMagasin";
import {getPerc} from "../svc/Utils";
import PercentIcon from '@mui/icons-material/ArrowRight';

export default function DpeScale({scalecolor, text, dpe, nbDpesV2, changeState, title, chV1, chV2}) {
    const [state, setState] = React.useState({
        "A": true,
        "B": true,
        "C": true,
        "D": true,
        "E": true,
        "F": true,
        "G": true
    });
    if (dpe) {
        return (
            <Box sx={{width: "20%", ml: 1, mr: 1}}>
                <Box sx={{width: 250, display: "flex", height: 25, alignItems: "center"}}>
                    <Typography sx={{width: 180, textAlign: "center"}} variant="subtitle1">{title}</Typography>
                    {chV1}
                    {chV2}
                </Box>
                <Box sx={{width: 250, height: 20, display: "flex"}}>
                    {changeState && <Checkbox sx={{p: 0}} size="small" checked={state.A} onClick={() => {
                        let tmpState = {...state, A: !state.A};
                        setState(tmpState)
                        changeState(tmpState);
                    }}/>}
                    <Box sx={{width: 250 - 60 - 80, backgroundColor: scalecolor.A, color: "#000"}}>
                        <Typography sx={{width: "100%", fontWeight: 'bold', pl: 1}}>{text.A}</Typography>
                    </Box>
                    <Box
                        sx={{
                            width: 80, color: "#000", textAlign: "center"
                        }}></Box>
                    <Box sx={{
                        width: 60, display: "flex", textAlign: "right", fontSize: "0.9em", alignItems: "center"
                    }}>
                        <Box sx={{display: "flex", alignItems: "center", width: "50%"}}>
                            {dpe["A"]}
                        </Box>
                        <Box sx={{display: "flex", alignItems: "center", width: "50%"}}>
                            {getPerc((dpe["A"]) / (nbDpesV2))}
                        </Box>
                    </Box>
                </Box>
                <Box sx={{width: 250, height: 20, display: "flex"}}>
                    {changeState && <Checkbox sx={{p: 0}} size="small" checked={state.B} onClick={() => {
                        let tmpState = {...state, B: !state.B};
                        setState(tmpState)
                        changeState(tmpState);

                    }}/>}
                    <Box sx={{width: 250 - 60 - 75, backgroundColor: scalecolor.B, color: "#000", fontWeight: 'bold'}}>
                        <Typography sx={{width: "100%", fontWeight: 'bold', pl: 1}}>{text.B}</Typography>
                    </Box>
                    <Box
                        sx={{
                            width: 75, color: "#000", textAlign: "center"
                        }}></Box>
                    <Box sx={{
                        width: 60, display: "flex", textAlign: "right", fontSize: "0.9em", alignItems: "center"
                    }}>
                        <Box sx={{display: "flex", alignItems: "center", width: "50%"}}>
                            {dpe["B"]}
                        </Box>
                        <Box sx={{display: "flex", alignItems: "center", width: "50%"}}>
                            {getPerc((dpe["B"]) / (nbDpesV2))}
                        </Box>
                    </Box>

                </Box>
                <Box sx={{width: 250, height: 20, display: "flex"}}>
                    {changeState && <Checkbox sx={{p: 0}} size="small" checked={state.C} onClick={() => {
                        let tmpState = {...state, C: !state.C};
                        setState(tmpState)
                        changeState(tmpState);
                    }}/>}
                    <Box sx={{width: 250 - 60 - 70, backgroundColor: scalecolor.C, color: "#000", fontWeight: 'bold'}}>
                        <Typography sx={{width: "100%", fontWeight: 'bold', pl: 1}}>{text.C}</Typography>
                    </Box>
                    <Box
                        sx={{
                            width: 70, color: "#000", textAlign: "center"
                        }}></Box>
                    <Box sx={{
                        width: 60, display: "flex", textAlign: "right", fontSize: "0.9em", alignItems: "center"
                    }}>
                        <Box sx={{display: "flex", alignItems: "center", width: "50%"}}>
                            {dpe["C"]}
                        </Box>
                        <Box sx={{display: "flex", alignItems: "center", width: "50%"}}>
                            {getPerc((dpe["C"]) / (nbDpesV2))}
                        </Box>
                    </Box>

                </Box>
                <Box sx={{width: 250, height: 20, display: "flex"}}>
                    {changeState && <Checkbox sx={{p: 0}} size="small" checked={state.D} onClick={() => {
                        let tmpState = {...state, D: !state.D};
                        setState(tmpState)
                        changeState(tmpState);
                    }}/>}
                    <Box sx={{width: 250 - 60 - 65, backgroundColor: scalecolor.D, color: "#000", fontWeight: 'bold'}}>
                        <Typography sx={{width: "100%", fontWeight: 'bold', pl: 1}}>{text.D}</Typography>
                    </Box>
                    <Box
                        sx={{
                            width: 65, color: "#000", textAlign: "center"
                        }}></Box>
                    <Box sx={{
                        width: 60, display: "flex", textAlign: "right", fontSize: "0.9em", alignItems: "center"
                    }}>
                        <Box sx={{display: "flex", alignItems: "center", width: "50%"}}>
                            {dpe["D"]}
                        </Box>
                        <Box sx={{display: "flex", alignItems: "center", width: "50%"}}>
                            {getPerc((dpe["D"]) / (nbDpesV2))}
                        </Box>
                    </Box>

                </Box>
                <Box sx={{width: 250, height: 20, display: "flex"}}>
                    {changeState && <Checkbox sx={{p: 0}} size="small" checked={state.E} onClick={() => {
                        let tmpState = {...state, E: !state.E};
                        setState(tmpState)
                        changeState(tmpState);
                    }}/>}
                    <Box sx={{width: 250 - 60 - 60, backgroundColor: scalecolor.E, color: "#000", fontWeight: 'bold'}}>
                        <Typography sx={{width: "100%", fontWeight: 'bold', pl: 1}}>{text.E}</Typography>

                    </Box>
                    <Box
                        sx={{
                            width: 60, color: "#000", textAlign: "center"
                        }}></Box>
                    <Box sx={{
                        width: 60, display: "flex", textAlign: "right", fontSize: "0.9em", alignItems: "center"
                    }}>
                        <Box sx={{display: "flex", alignItems: "center", width: "50%"}}>
                            {dpe["E"]}
                        </Box>
                        <Box sx={{display: "flex", alignItems: "center", width: "50%"}}>
                            {getPerc((dpe["E"]) / (nbDpesV2))}
                        </Box>
                    </Box>
                </Box>
                <Box sx={{width: 250, height: 20, display: "flex"}}>
                    {changeState && <Checkbox sx={{p: 0}} size="small" checked={state.F} onClick={() => {
                        let tmpState = {...state, F: !state.F};
                        setState(tmpState)
                        changeState(tmpState);
                    }}/>}
                    <Box sx={{width: 250 - 60 - 55, backgroundColor: scalecolor.F, color: "#000", fontWeight: 'bold'}}>
                        <Typography sx={{width: "100%", fontWeight: 'bold', pl: 1}}>{text.F}</Typography>
                    </Box>
                    <Box
                        sx={{
                            width: 55, color: "#000", textAlign: "center"
                        }}></Box>
                    <Box sx={{
                        width: 60, display: "flex", textAlign: "right", fontSize: "0.9em", alignItems: "center"
                    }}>
                        <Box sx={{display: "flex", alignItems: "center", width: "50%"}}>
                            {dpe["F"]}
                        </Box>
                        <Box sx={{display: "flex", alignItems: "center", width: "50%"}}>
                            {getPerc((dpe["F"]) / (nbDpesV2))}
                        </Box>
                    </Box>

                </Box>
                <Box sx={{width: 250, height: 20, display: "flex"}}>
                    {changeState && <Checkbox sx={{p: 0}} size="small" checked={state.G} onClick={() => {
                        let tmpState = {...state, G: !state.G};
                        setState(tmpState)
                        changeState(tmpState);
                    }}/>}
                    <Box sx={{width: 250 - 60 - 50, backgroundColor: scalecolor.G, color: "#000", fontWeight: 'bold'}}>
                        <Typography sx={{width: "100%", fontWeight: 'bold', pl: 1}}>{text.G}</Typography>
                    </Box>
                    <Box
                        sx={{
                            width: 50, color: "#000", textAlign: "center"
                        }}></Box>
                    <Box sx={{
                        width: 60, display: "flex", textAlign: "right", fontSize: "0.9em", alignItems: "center"
                    }}>
                        <Box sx={{display: "flex", alignItems: "center", width: "50%"}}>
                            {dpe["G"]}
                        </Box>
                        <Box sx={{display: "flex", alignItems: "center", width: "50%"}}>
                            {getPerc((dpe["G"]) / (nbDpesV2))}
                        </Box>
                    </Box>

                </Box>

            </Box>
        )
    }

}

 */
